import { atom } from 'recoil'

export const mediaAtom = atom({
   key: 'mediaState',
   default: []
})
